import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wo_044",
  "use": "icon-wo_044-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-wo_044\"><defs><style>#icon-wo_044 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-wo_044_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-wo_044_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><rect class=\"cls-2\" x=\"4\" y=\"9\" width=\"14\" height=\"6\" /><path class=\"cls-2\" d=\"M20,7v3h2v4H20v3H2V7H20m2-2H0V19H22V16h2V8H22V5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol